
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const RESERVATION_FLOW_PAGES = [
  '/veiculos',
  '/extras',
  '/condutor',
  '/pagamento',
  '/reserva',
  '/analise',
];

export default function RateExpirationHandler() {
  const router = useRouter();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    const handleExpiration = () => {
      const rateExpStr = router.query.rate_exp as string;

      if (!rateExpStr || !RESERVATION_FLOW_PAGES.some(path => router.pathname.startsWith(path))) {
        return;
      }

      const rateExp = parseInt(rateExpStr, 10);

      if (isNaN(rateExp)) {
        return;
      }

      const now = Date.now();
      const timeoutDuration = rateExp - now;

      if (timeoutDuration <= 0) {
        router.replace('/');
        return;
      }

      timer = setTimeout(() => {
        router.replace('/');
      }, timeoutDuration);
    }

    handleExpiration();

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [router.query.rate_exp, router.pathname, router]);

  return null;
}
